import { isCordova } from 'e-submission/utils'
import PhotoCard from 'e-submission/components/Card/PhotoCard'
import { CheckedCard, NotCheckedCard, NotCheckedWithInputCard } from 'e-submission/components/Card/DocumentCard'

const Component = ({ icon = 'camera', ...props }) => {

  const documents = props.value
  const validateFile = props.validate
  const isBrowseFile = props.isBrowseFile
  const action = isCordova && !isBrowseFile ? 'ถ่ายรูป' : 'แนบรูป'

  return (
    <div>
      {documents.map((documentProps, index) => (
        <PhotoCard
          key={index}
          icon={icon}
          action={action}
          validateFile={validateFile}
          CheckedComponent={CheckedCard}
          NotCheckedComponent={documentProps.editable ? NotCheckedWithInputCard : NotCheckedCard}
          {...documentProps}
          {...props}
        />
      ))}
    </div>
  )
}

export default (hoc) => (Component)
